// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"216":"43a1fd0d","339":"3f731650"}[chunkId] + ".chunk.js";
};